import { Utils } from '@genial/utils';

import { RiskRating } from '../../../../../../../../../../components/RiskRating';
import { PublicOfferTypes } from '../../../../../../../../../../store/product/external/constants';
import {
  PublicOfferAssetToInvestNormalized,
  PublicOfferDetailsModalityWithTimelineNormalized,
} from '../../../../../../../../../../store/product/types';
import { ProductCardItemProps } from '../../../../components/ProductCardItem';

export const getProductInfos = (
  publicOfferType: PublicOfferTypes,
  publicAsset?: PublicOfferAssetToInvestNormalized | null,
  modality?: PublicOfferDetailsModalityWithTimelineNormalized
): ProductCardItemProps[] => {
  const minimumApplication: ProductCardItemProps = {
    label: 'Aplicação Mínima',
    value: modality?.minimumApplicationFormatted || 'Selecione uma modalidade',
  };
  const maximumApplication: ProductCardItemProps = {
    label: 'Aplicação Máxima',
    value: modality?.maximumApplicationFormatted || 'Selecione uma modalidade',
  };
  const risk: ProductCardItemProps = {
    label: 'Perfil de risco',
    loading: !publicAsset,
    value: (
      <RiskRating
        currentRiskRating={Number(publicAsset?.riskRatingCode) || 0}
        tooltip={publicAsset?.riskRating || ''}
      />
    ),
  };
  const solicitationDate: ProductCardItemProps = {
    label: 'Data de solicitação',
    value: Utils.Mask.DateFormat(new Date(), 'dd/MM/yyyy'),
  };
  const issuer: ProductCardItemProps = {
    label: 'Emissor',
    loading: !publicAsset,
    value: publicAsset?.issuer || '',
  };
  const rating: ProductCardItemProps = {
    label: 'Rating',
    loading: !publicAsset,
    value: publicAsset?.rating || '',
  };
  const deadlineMonths: ProductCardItemProps = {
    label: 'Prazo',
    loading: !publicAsset,
    value: publicAsset?.deadlineMonthsFormatted || '',
  };

  switch (publicOfferType) {
    case PublicOfferTypes.EQUITY_FIXED:
    case PublicOfferTypes.EQUITY_MAX_VALUE_FOREACH:
    case PublicOfferTypes.FII_FIXED:
      return [minimumApplication, maximumApplication, risk, solicitationDate];
    case PublicOfferTypes.CRA_MINIMUM_REMUNERATION:
    case PublicOfferTypes.COE_FIXED:
      return [
        minimumApplication,
        maximumApplication,
        issuer,
        rating,
        risk,
        solicitationDate,
        deadlineMonths,
      ];
    case PublicOfferTypes.DEB_MINIMUM_REMUNERATION:
    case PublicOfferTypes.DEB_FIXED:
    case PublicOfferTypes.FII_MINIMUM_REMUNERATION:
      return [
        minimumApplication,
        maximumApplication,
        issuer,
        risk,
        solicitationDate,
        deadlineMonths,
      ];
    default:
      break;
  }

  return [
    minimumApplication,
    maximumApplication,
    risk,
    solicitationDate,
    issuer,
    rating,
    deadlineMonths,
  ];
};

export const getExtraInfos = (
  publicOfferType: PublicOfferTypes,
  publicAsset?: PublicOfferAssetToInvestNormalized | null
): ProductCardItemProps[] => {
  const unitaryPrice: ProductCardItemProps = {
    label: 'Preço unitário',
    value: publicAsset?.unitaryPriceFormatted || '',
    loading: !publicAsset,
  };

  const valueAlreadyAssigned: ProductCardItemProps = {
    label: 'Valor já reservado',
    value: publicAsset?.valueAlreadyAssignedFormatted,
    loading: !publicAsset,
  };
  const valueAlreadyAssignedShouldBeHidden = !valueAlreadyAssigned.value
    ? []
    : [valueAlreadyAssigned];

  switch (publicOfferType) {
    case PublicOfferTypes.EQUITY_FIXED:
    case PublicOfferTypes.COE_FIXED:
    case PublicOfferTypes.DEB_FIXED:
    case PublicOfferTypes.FII_FIXED:
    case PublicOfferTypes.FIDC_FIXED:
      return [unitaryPrice, ...valueAlreadyAssignedShouldBeHidden];

    default:
      break;
  }

  return [...valueAlreadyAssignedShouldBeHidden];
};
